// 分别返回arr1中拥有但是arr2没有的条目 和 arr2中有arr1中没有的条目
export const twoArrInlcudeNode = (arr1, arr2) => {
  arr1 = arr1 || []
  arr2 = arr2 || []
  const newArr1 = []
  const newArr2 = []
  const hash1 = arr1.reduce((total, item) => {
    total[item.id] = true
    return total
  }, {})
  const hash2 = arr2.reduce((total, item) => {
    total[item.id] = true
    return total
  }, {})
  arr1.forEach(item => {
    if (!hash2[item.id]) {
      newArr1.push(item.id)
    }
  });
  arr2.forEach(item => {
    if (!hash1[item.id]) {
      newArr2.push(item.id)
    }
  });
  return [newArr1, newArr2]
}

// 过滤掉del的节点
export const filterDel = (arr, newArr = []) => {
  for (let i = 0; i < arr.length; i++) {
      if (arr[i].del) continue;
      const {items, ...other} = arr[i]
      const obj = {...other}
      if (items && items.length > 0) {
          obj.items = filterDel(items)
      }
      newArr.push(obj)
  }
  return newArr
}
// 收集所有已选的条目
export const collectCheckedItems = (arr, newArr = []) => {
  for (let i = 0; i < arr.length; i++) {
     if (!arr[i].checkout) continue;
     newArr.push(arr[i].id)
     if (arr[i].items && arr[i].items.length > 0) {
      collectCheckedItems(arr[i].items, newArr)
     } 
  }
  return newArr
}

// 路由管理修改条目提交数据
export const submitData = (formdata) => {
  const { route_type, path } = formdata
  let _path = null
  let result = null
  switch (route_type) {
    case 'powerbi':
      result = {...formdata, path:''}
      break
    case 'iframe':
      result = {...formdata, pb_workspace_id:'', pb_report_id:''}
      break
    case 'button':
       _path = path[0] === '/' ? path : ''
       result = {...formdata, pb_workspace_id:'', pb_report_id:'', path:_path}
       break
    default:
      result = {...formdata, pb_workspace_id:'', pb_report_id:''}
      break
  }
  result.path = result.path === 'NO_PATH' ? '' : result.path
  result.auth_key = result.auth_key || undefined
  return result
}

// path的拓扑关系
export const pathTopology = (paths, root = [], hash = {}) => {
    for (let i = 0, len = paths.length; i < len; i++) {
      const child = paths[i]
      root.push(child.name)
      if (child.path && child.path[0] === '/' && !child.path.includes(':')) {
        hash[child.path] = root.join('-')
      }
      if (child.items && child.items.length) {
        pathTopology(child.items, root, hash)
      }
      root.pop()
    }
    return hash
}
